import styled from 'styled-components';
import { Col, Image, type ImageProps } from 'antd';

interface ThumbnailProps extends ImageProps {
	$hasError: boolean;
}

export const Container = styled(Col)`
	position: relative;
	border-radius: ${({ theme }) => theme.border.border_radius.br_md};
	.ant-image {
		border-radius: ${({ theme }) => theme.border.border_radius.br_md};
		img {
			height: 270px;
			width: 400px;
			object-fit: cover;
			border-radius: ${({ theme }) => theme.border.border_radius.br_md};
			box-shadow: 1px 1px 5px 0px #00000026;
		}
	}
	&:hover .actions {
		opacity: 1;
		visibility: visible;
	}
`;

export const Thumbnail = styled(Image)<ThumbnailProps>`
	max-height: 185px;
	max-width: 150px;
	object-fit: cover;
	border-radius: ${({ theme }) => theme.border.border_radius.br_md};
	margin-right: 10px;
	border: ${({ theme, $hasError }) => ($hasError ? `1px solid ${theme.colors.danger}` : 'none')};
`;

export const Actions = styled(Col)`
	position: absolute;
	width: 100%;
	height: 100%;
	opacity: 0;
	visibility: hidden;
	border-radius: ${({ theme }) => theme.border.border_radius.br_md};
	background-color: #fffffff2;
	.ant-col {
		display: flex;
		justify-content: center;
		button {
			border: none;
			color: ${({ theme }) => theme.colors.primary};
			background: transparent;
			.ant-col {
				padding: 0 !important;
			}
			svg {
				font-size: 2rem;
			}
			&:disabled {
				color: #d9d9d9;
			}
		}
		button.ant-btn-dangerous {
			color: #ff4d4f;
			background: transparent;
		}
	}
`;
